import { PrimaryColors } from 'src/types/globalTypes';
import DropdownInfo from 'src/components/ui-kit/DropdownInfo';
import { TmarkDivide } from 'src/types/api/trademarkRightsApiTypes';
import { Table, Item, Title, Content } from 'src/components/contents/detail/DetailPage';

interface Iprops {
  data: TmarkDivide;
  isShow: boolean;
  setIsShow: (isShow: boolean) => void;
  colorType: PrimaryColors;
  noContent: JSX.Element;
}

/**
 * 商標分割紀錄 區塊。
 */
const InfoTmarkDivide: React.FC<Iprops> = ({ data, isShow, setIsShow, colorType, noContent }) => {
  const tableColor = colorType.third;
  const angleColor = colorType.fifth;

  return (
    <DropdownInfo title={`商標分割紀錄`} isShow={isShow} setIsShow={setIsShow} color={angleColor}>
      <Table color={tableColor}>
        <Item>
          <Title>分割日期</Title>
          <Content>{data.divideDate || noContent}</Content>
          <Title>原註冊號</Title>
          <Content>{data.tmarkDivideOrigin.originExamNo || noContent}</Content>
        </Item>
        <Item>
          <Title>原註冊號商標種類</Title>
          <Content>{data.origintmarkClass || noContent}</Content>
        </Item>
      </Table>
    </DropdownInfo>
  );
};

export default InfoTmarkDivide;
